document.addEventListener("DOMContentLoaded", function () {
  const openBtns = document.querySelectorAll(".open-supplement-popup");
  const popup = document.querySelector(".custom-popup-box");
  const closeBtn = popup?.querySelector(".close");
  const content = popup?.querySelector(".popup-content");

  if (!popup || openBtns.length === 0 || !closeBtn || !content) return;

  let lastScrollY = 0;

  function onKeyDown(e) {
    if (e.key === "Escape") closePopup();
  }

  function openPopup(e) {
    if (e) e.preventDefault();
    popup.style.display = "block";

    lastScrollY = window.scrollY || window.pageYOffset;
    document.body.classList.add("no-scroll");

    content.setAttribute("tabindex", "-1");
    content.focus();

    document.addEventListener("keydown", onKeyDown);
  }

  function closePopup() {
    popup.style.display = "none";

    document.body.classList.remove("no-scroll");
    window.scrollTo(0, lastScrollY);

    document.removeEventListener("keydown", onKeyDown);
  }
  openBtns.forEach((btn) => btn.addEventListener("click", openPopup));
  closeBtn.addEventListener("click", closePopup);
  popup.addEventListener("click", function (e) {
    if (!e.target.closest(".popup-content")) closePopup();
  });
});
